/** Write the wizard's per-party pronoun choice into the run's prompt variables
 *  in the form the engine reads (`pronouns_party_a` / `pronouns_party_b`, e.g.
 *  "she/her"; evals/tools.py `pronoun_note_from_prompt_vars`). A party with no
 *  choice gets NO key: absent means not declared, and the readability pass
 *  then uses first names for that party. Mutates and returns `promptVars`. */
export function applyPronounsToPromptVars(
  promptVars: Record<string, unknown>,
  partyA: string,
  partyB: string,
  pronouns: Record<string, string | undefined>,
): Record<string, unknown> {
  const pairs: Array<[string, string]> = [
    [partyA, "pronouns_party_a"],
    [partyB, "pronouns_party_b"],
  ];
  for (const [name, key] of pairs) {
    const value = (pronouns[name] ?? "").trim();
    if (value) promptVars[key] = value;
    else delete promptVars[key];
  }
  return promptVars;
}
